import { isQueryFlagEnabled } from '@openhouse-engineers/oh-js-utils/lib/utils/url'

import { isFunction } from 'helpers/miscellaneous'

const countFn = window.console.count

if (isFunction(countFn)) {
    const isDebugEnabled = isQueryFlagEnabled(window.location.href, 'debug')

    window.console.count = function() {
        if (!isDebugEnabled) return

        countFn(...arguments)
    }
}
